interface SchemaMarkupScriptProps {
  name: string
  description: string
}

export const SchemaMarkupScript = (props: SchemaMarkupScriptProps) => {
  const { name, description } = props

  const webPageSchema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name,
    description,
    publisher: {
      '@type': 'Organization',
      name: 'Grammarly',
      url: 'https://www.grammarly.com/',
    },
  }

  const softwareAppSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    applicationCategory: 'ProductivityApplication',
    operatingSystem: 'Web',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 4.6,
      bestRating: '5',
      worstRating: '1',
      ratingCount: 176200,
    },
    offers: {
      '@type': 'Offer',
      price: '0.00',
      priceCurrency: 'USD',
    },
  }

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareAppSchema) }} />
    </>
  )
}
